import React, { useState, useEffect } from 'react';
import useAuthStore from '../store/authStore';

const STORAGE_KEY = 'jatear_push_banner_dispensado';

export default function PushBloqueadoBanner() {
  const usuario = useAuthStore(s => s.usuario);
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    if (!usuario?.uid) return;
    if (!('Notification' in window)) return;
    if (Notification.permission !== 'denied') return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    // Pequeno delay para não aparecer junto com o carregamento da página
    const t = setTimeout(() => setVisivel(true), 2000);
    return () => clearTimeout(t);
  }, [usuario?.uid]);

  function dispensar() {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setVisivel(false);
  }

  if (!visivel) return null;

  // Detecta navegador para instrução correta
  const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
  const instrucao = isFirefox
    ? 'Clique no cadeado 🔒 na barra de endereços → Permissões → Enviar notificações → Permitir'
    : 'Clique no cadeado 🔒 na barra de endereços → Notificações → Permitir';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9997,
      background: '#1a1a1a',
      color: '#fff',
      padding: '10px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
      animation: 'slideDown 0.3s ease',
    }}>
      <style>{`
        @keyframes slideDown {
          from { transform: translateY(-100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>

      <span style={{ fontSize: '18px', flexShrink: 0 }}>🔔</span>

      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '2px' }}>
          Notificações bloqueadas
        </div>
        <div style={{ fontSize: '11px', opacity: 0.75, lineHeight: '1.4' }}>
          Você não receberá alertas de treinamentos vencendo, novos cursos ou pesquisas.
          Para reativar: {instrucao}.
        </div>
      </div>

      <button
        onClick={dispensar}
        style={{
          background: 'rgba(255,255,255,0.15)',
          border: 'none',
          color: '#fff',
          padding: '5px 12px',
          borderRadius: '6px',
          fontSize: '12px',
          fontWeight: '600',
          cursor: 'pointer',
          flexShrink: 0,
          whiteSpace: 'nowrap',
        }}
      >
        Entendi
      </button>
    </div>
  );
}
